// SW-200 - Used to provide a proxy email ident when no email is provided. This is used to indicate that the supporter did not provife an email.
export const NO_EMAIL_PROVIDED_IDENT = "unknown-email-is-opt-in@example.com";
